import React, { FC } from 'react';

import { BasketItemBundleDiscount } from '../BasketItemBundleDiscount/BasketItemBundleDiscount';

import { UpsellInformation } from './types';

interface UpsellBundleInformationProps {
  shouldRender: boolean;
  upsellInformation: UpsellInformation;
}

export const UpsellBundleInformation: FC<UpsellBundleInformationProps> = ({
  shouldRender,
  upsellInformation,
}) => {
  if (!shouldRender) {
    return null;
  }
  return (
    <BasketItemBundleDiscount
      promoLabel={upsellInformation.label}
      missingBundleItems={upsellInformation.remainingItemsForBundle}
      redirectUrl={upsellInformation.url}
    />
  );
};
